import { isFeatureEnabled } from 'owa-feature-flags';

export default function isSonoraPluginVivaTopicPeopleSuggestionsEnabled(): boolean {
    return (
        isFeatureEnabled('honeybee-sonora-vivaTopic') &&
        isFeatureEnabled('honeybee-sonora-vivaTopicPeopleSuggestions')
    );
}
